import { HoldStateProvider } from "./HoldState.provider";
import { PromotionHoldState, TicketTypeState } from "@/domain/ticket-selection";

/**
 * PromotionHoldStateProvider
 * data provider class for PromotionHold price list level
 */
export class PromotionHoldStateProvider {

    public static updatedPromotionHoldForActiveTicketTypes(
        updatedState: TicketTypeState[],
        promotionHold: PromotionHoldState
    ): PromotionHoldState {
        if (promotionHold.active && promotionHold.holds) {
            promotionHold.holds = promotionHold.holds.map(hold =>
                HoldStateProvider.updatedHoldForActiveTicketTypes(updatedState, hold)
            )
        }

        return promotionHold;
    }

}
